import * as React from "react";
import { forwardRef } from "react";
const AndroidIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M6.928 13.519a.795.795 0 0 1 1.011.327l.004.007a.796.796 0 0 1 .079.602.79.79 0 0 1-.369.481l-.007.004a.796.796 0 0 1-.602.079.79.79 0 0 1-.481-.369l-.004-.007a.796.796 0 0 1 .29-1.083l.007-.004.072-.037zm9.509 0a.794.794 0 0 1 1.011.327l.004.007a.796.796 0 0 1 .079.602.79.79 0 0 1-.369.481l-.007.004a.794.794 0 0 1-.601.079.79.79 0 0 1-.482-.369l-.004-.007a.796.796 0 0 1-.079-.602.79.79 0 0 1 .369-.481l.007-.004.072-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.965 6.242a.75.75 0 1 1 1.278.785L17.45 9.946c2.921 1.817 4.911 5.047 5.087 8.754a1.232 1.232 0 0 1-1.237 1.285H2.7A1.231 1.231 0 0 1 1.463 18.7c.175-3.691 2.149-6.909 5.049-8.73L4.704 7.028a.75.75 0 1 1 1.278-.785l1.855 3.021A10.265 10.265 0 0 1 12 8.385c1.464 0 2.855.309 4.12.861l1.846-3.004zM12 9.885c-4.734 0-8.648 3.769-9.019 8.6h18.037c-.371-4.831-4.284-8.6-9.019-8.6z"
}));
const ForwardRef = forwardRef(AndroidIcon);
export default ForwardRef;